import React from 'react';

const PageNotFound = () => {

  return (
    <div>
      <h1>Page not found, sorry.</h1>
    </div>
  )
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/PageNotFound.js